export const colors = {
  interactionPrimary: '#ff8f16',
  interactionPrimaryHover: '#e58114',
  interactionPrimaryPressed: '#cc7212',
  interactionSecondary: '#0e97c2',
  interactionSecondaryHover: '#0d88af',
  interactionSecondaryPressed: '#0b799b',
  interactionNeutral: '#595959',
  interactionNeutralHover: '#696969',
  interactionNeutralPressed: '#7a7a7a',
  interactionSuccess: '#00a54c',
  interactionSuccessHover: '#009544',
  interactionSuccessPressed: '#00843d',
  interactionDanger: '#ff000a',
  // not in design system
  interactionDangerHover: '#e60009',
  // not in design system
  interactionDangerPressed: '#cc0108',
  // not in design system
  contentPrimary: '#222222',
  contentSecondary: '#595959',
  contentTertiary: '#aaaaaa',
  contentStateDisabled: '#c9c9c9',
  contentInversePrimary: '#ffffff',
  contentBrand: '#002873',
  contentAdditionalA: '#e8494f',
  contentAdditionalB: '#df7400',
  contentAdditionalC: '#f6ad2c',
  contentAdditionalD: '#85bc39',
  contentAdditionalE: '#C3C718',
  contentPromotionA: '#e8494f',
  contentPromotionB: '#f0a787',
  contentPromotionC: '#51b295',
  backgroundPrimary: '#ffffff',
  backgroundSecondary: '#e9e9e9',
  backgroundTertiary: '#f8f8f8',
  backgroundDark: '#383838',
  backgroundOverlay: 'rgba(34, 34, 34, 0.5)',
  backgroundBrand: '#002873',
  backgroundBrandDark: '#0b2658',
  backgroundStateSelectedTransparent: 'rgba(14, 151, 194, 0.1)',
  backgroundInteractionSecondaryTransparentLight: 'rgba(14, 151, 194, 0.3)',
  backgroundInteractionSecondaryTransparentDark: 'rgba(14, 151, 194, 0.8)',
  backgroundInteractionSecondaryTransparentBlack: 'rgba(0, 0, 0, 0.2)',
  // not in design system
  backgroundInteractionSecondaryTransparentWhite: 'rgba(255, 255, 255, 0.1)',
  // not in design system
  backgroundStateDisabled: '#e0e0e0',
  backgroundStateHover: '#f5f5f5',
  backgroundStateSelected: '#e7f5f9',
  backgroundStateSelectedSecondary: '#fff2f3',
  borderPrimary: '#c8c8c8',
  borderSecondary: '#e9e9e9',
  borderSelection: '#0e97c2',
  borderInverse: '#ffffff',
  borderStateDisabled: '#e0e0e0',
  borderStateHover: '#959595',
  systemPositive: '#00a54c',
  systemPositiveHover: '#009544',
  systemPositiveAlert: '#00843d',
  systemPositiveBackground: '#e5f6ed',
  systemPositiveBackgroundHover: '#cceddb',
  systemPositiveBackgroundPressed: '#b3e4c9',
  systemWarning: '#f6ad2c',
  systemWarningHover: '#dd9c28',
  systemWarningAlert: '#c58a23',
  systemWarningBackground: '#fef7ea',
  systemWarningBackgroundHover: '#fdefd5',
  systemWarningBackgroundPressed: '#fce6c0',
  systemError: '#ff000a',
  systemErrorHover: '#e50009',
  systemErrorAlert: '#cc0008',
  systemErrorBackground: '#ffe5e6',
  systemErrorBackgroundHover: '#ffccce',
  systemErrorBackgroundPressed: '#ffb3b5',
  // component specific overrides, use sparingly!
  buttonPrimaryInfoColor: '#ffffff',
  // contentInversePrimary
  buttonPrimarySuccessColor: '#ffffff',
  // contentInversePrimary
  buttonPrimaryWarningColor: '#ffffff',
  // contentInversePrimary
  // not meant to be used
  brandA: '#002873',
  brandB: '#e8494f',
  brandC: '#f6ad2c',
  brandNeutralA: '#222222',
  brandNeutralB: '#ffffff',
  marketingA: '#ff8f16',
  marketingB: '#ff9c31',
  marketingC: '#9ed8e1',
  marketingD: '#c7e5dc',
  focusState: '#ff39dc'
};